import { Attributes, NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";
import { TimeZoneFormat } from "@singularsystems/neo-core/dist/Misc";

@NeoModel
export default class ExportFilesSentReportCriteria extends ValueObject  
{
    @Rules.Required()
    @Attributes.Date(TimeZoneFormat.None)
    public dateReport: Date | null = null;
}